module.exports = __webpack_public_path__ + "static/media/aierkang2.93ff7ed0.png";